<template>
  <b-modal
    ref="modal-createcampanhalista"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione qual lista de campanha deseja atribuir
    </template>

      <div>
      <label class="form-label">Deseja executar agora ou programar?</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="execute-now"
          value="now"
          v-model="executeOption"
        />
        <label class="form-check-label" for="execute-now">
          Executar agora
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="schedule"
          value="schedule"
          v-model="executeOption"
        />
        <label class="form-check-label" for="schedule">
          Programar
        </label>
      </div>
      <div v-if="currentRecurrence">
          <label class="form-label">Status</label>
          <ToogleSwitch v-model="status"/>
        </div>
    </div>
    <ModalPeriodicidade
      v-if="executeOption === 'schedule'"
      ref="ModalPeriodicidade"
      :trigger-generate="generateCronTrigger"
      @cron-generated="handleCronGenerated"
      :cron-expression="currentRecurrence ? currentRecurrence.cronPeriodicidade : null"

    />
      <label>
        <small
          v-if="form.campanhaListaId.required"
          class="text-danger"
        >*</small> Lista:</label>
      <div class="input-group">
        <b-dropdown variant="addon" no-caret>
          <template slot="button-content">
            <i class="fas fa-caret-down" />
          </template>
          <b-dropdown-item @click="onAddSegmentationModal">
            <i class="fas fa-plus text-third" /> Criar
          </b-dropdown-item>
          <b-dropdown-item
            @click="onEditSegmentationModal"
            :disabled="form.campanhaListaId.value === null"
          >
            <i class="fas fa-edit  text-third" /> Editar
          </b-dropdown-item>
        </b-dropdown>
        <b-form-select
          v-model="form.campanhaListaId.value"
          :options="form.campanhaListaId.options"
        >
          <template slot="first">
            <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
          </template>
        </b-form-select>
      </div>
    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="onSave"
      icon="fas fa-check-circle"
      text="Salvar"
    />

    <AddNewCampanhaListaModal
      ref="addSegmentationModal"
      @reload="onGetAllSegmentation"
    />
  </b-modal>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'
import RecorrenciaListaInteligenteRepository from '@/shared/http/repositories/configurations/recorrenciaListaInteligente.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import AddNewCampanhaListaModal from '@/views/private/configurations/lista-inteligente/components/add/modal/AddNewCampanhaListaModal.vue'
import ModalPeriodicidade from '../component/ModalPeriodicidade.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

const AcaoListaInteligenteData = {
  campanhaListaId: null,
  acaoListaInteligente: null,
  cronExpression: ''
}

const AcaoListaInteligenteForm = {
  campanhaListaId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  acaoListaInteligente: {
    value: null,
    defaultValue: 'CREATE_LIST_CAMPAIGN'
  }
}

export default {
  name: 'CreateCampanhaListaModal',
  mixins: [ActionsForm],
  components: {
    DefaultButton,
    AddNewCampanhaListaModal,
    ModalPeriodicidade,
    ToogleSwitch
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      form: AcaoListaInteligenteForm,
      acaoListaId: null,
      executeOption: 'now',
      generateCronTrigger: false,
      status: false
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.getRecorrencia()
        this.$refs['modal-createcampanhalista'].show()
        this.onGetAllSegmentation()
      }
    },
    hideModal () {
      this.$refs['modal-createcampanhalista'].hide()
    },
    onCreate () {
      if (this.executeOption === 'schedule') {
        this.generateCronTrigger = true
        this.$nextTick(() => {
          this.generateCronTrigger = false
        })
      } else {
        this.finalizeCreateAcao()
      }
    },
    handleCronGenerated (cronExpression) {
      this.data.cronExpression = cronExpression
      const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'CREATE_LIST_CAMPAIGN')

      if (foundRecurrence) {
        this.updateRecorrencia()
        this.$emit('reloadAcoes')
      } else {
        this.createRecorrencia()
        this.$emit('reloadAcoes')
      }
    },
    finalizeCreateAcao () {
      loading.push()
      ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onAddSegmentationModal () {
      this.$refs.addSegmentationModal.showModal()
    },
    onEditSegmentationModal () {
      SegmentationRepository.GetById(this.form.campanhaListaId.value)
        .then((response) => {
          const { data } = response
          this.$refs.addSegmentationModal.onEdit(data)
        })
        .catch(this.onException)
    },
    onGetAllSegmentation () {
      loading.push()
      SegmentationRepository.GetAllSortedByNome()
        .then((response) => {
          this.form.campanhaListaId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    },
    createRecorrencia () {
      const payload = {
        listaInteligenteId: this.acaoListaId,
        campanhaListaId: this.data.campanhaListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente
      }

      RecorrenciaListaInteligenteRepository.Create(payload)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao criar recorrência:', error)
        })
    },
    getRecorrencia () {
      RecorrenciaListaInteligenteRepository.GetById(this.acaoListaId)
        .then((response) => {
          if (response.status === 200 && Array.isArray(response.data.content)) {
            this.recorrencia = response.data.content

            const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'CREATE_LIST_CAMPAIGN')

            if (foundRecurrence) {
              this.currentRecurrence = foundRecurrence
              this.executeOption = 'schedule'
              this.data.cronExpression = foundRecurrence.cronPeriodicidade
              this.editCronExpression = this.data.cronExpression
              this.campanhaListaId = foundRecurrence.campanhaListaId
              this.form.campanhaListaId.value = foundRecurrence.campanhaListaId
              this.status = foundRecurrence.status
            } else {
              this.currentRecurrence = null
              this.executeOption = 'now'
              this.data.cronExpression = null
              this.form.campanhaListaId.value = null
            }
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar recorrência:', error)
        })
    },
    updateRecorrencia () {
      if (!this.currentRecurrence) {
        return
      }

      const payload = {
        id: this.currentRecurrence.id,
        listaInteligenteId: this.acaoListaId,
        campanhaListaId: this.data.campanhaListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente,
        status: this.status
      }
      RecorrenciaListaInteligenteRepository.Update(payload)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao atualizar recorrência:', error)
        })
    },
    toggleCreateUser () {
      this.status = !this.status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/CreateCampanhaListaModal.vue